/**
 * Fußzeile: Copyright, Impressum, Datenschutz und Version. Die Verweise
 * erscheinen nur, wenn sie im Betrieb gesetzt sind (IMPRINT_URL,
 * PRIVACY_URL); sie öffnen in einem neuen Tab, damit die App offen bleibt.
 */
import { useAppInfo } from '../state/appInfo.ts';
import { texts } from '../texts/de.ts';

/** Fußzeile der App. */
export function AppFooter({ className = '' }: { readonly className?: string }) {
  const info = useAppInfo();
  const links: { href: string; label: string }[] = [];
  if (info?.imprintUrl) {
    links.push({ href: info.imprintUrl, label: texts.footer.imprint });
  }
  if (info?.privacyUrl) {
    links.push({ href: info.privacyUrl, label: texts.footer.privacy });
  }

  return (
    <footer
      className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-4 text-xs text-content-muted print:hidden ${className}`}
    >
      <span>{texts.footer.copyright.replace('{year}', String(new Date().getFullYear()))}</span>
      {links.map((link) => (
        <a
          key={link.href}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-content"
        >
          {link.label}
        </a>
      ))}
      {info === null ? null : <span>{texts.footer.version.replace('{version}', info.version)}</span>}
    </footer>
  );
}
